export default {
    season: 'SEASON {{current}} of {{total}}',
    race: 'RACE {{current}} of {{total}}',
    breadCrumb: {
        step1: 'INVESTMENT & PLANNING',
        step2: 'PRE-RACE',
        step3: 'RACE',
        step4: 'POST-RACE',
        step5: 'POST-SEASON'
    },
    title: 'MC VISUAL',
    code: 'Code',
    gameCode: 'GAME CODE'
}



// WEBPACK FOOTER //
// src/lang/locales/en/statusBar.js